export default __webpack_public_path__ + "static/media/sf-yogi.1e5af09f.jpg";